<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import TextNodes from "@Components/TextNodes/TextNodes.vue";
import Step from "@Components/Stepper/Step.vue";
import { TrashIcon } from "@heroicons/vue/20/solid";
import { useForm } from "@/form";
import { useRoute } from "vue-router";

const props = defineProps(["modelValue", "step"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();

const nodes = ref();

const actions = {
    header: [],
    footer: [],
    row: [
        {
            icon: TrashIcon,
            tooltip: __("Supprimer"),
            label: null,
            onHandle: (action, { deleteRow }) => {
                deleteRow();
            },
        },
    ],
};

const { params: routeParams, query: routeQuery } = useRoute();

onMounted(async () => {
    let ids = decodeURIComponent(routeQuery.ids).split(",");

    if (ids.length > 0) {
        const response = await useForm({
            ids: ids,
        }).post("requests_get_posts");

        nodes.value.replaceRows(response);
    }
});
</script>

<template>
    <Step class="px-4 lg:px-8 sm:px-6" :step="step" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')">
        <template #header>
            <div class="mx-auto max-w-3xl">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Vos titres") }}
                </h3>
            </div>
        </template>
        <div class="mx-auto flex flex-col">
            <TextNodes ref="nodes" v-model="modelValue.requests" :actions="actions" disable-new-rows :depth-enabled="false" sortable-enabled :readonly="true" />
        </div>
    </Step>
</template>
